import Measured from './Measured';
import { connect, } from 'react-redux';
import { makeGetPrevLoadDims } from './redux/selectors';
import { updateMeasuredCookie } from './redux/actions';
var withCookie = function (props) {
    return props.cookieType !== undefined && props.cookieDim !== undefined;
};
var makeMapStateToProps = function () {
    var getPrevLoadDims = makeGetPrevLoadDims();
    return function (state, ownProps) {
        if (!withCookie(ownProps)) {
            return {};
        }
        return {
            prevLoadDims: getPrevLoadDims(state, ownProps.cookieType, ownProps.cookieDim),
        };
    };
};
var mapDispatchToProps = function (dispatch, ownProps) { return ({
    onUpdatedDims: function (size) {
        withCookie(ownProps) &&
            dispatch(updateMeasuredCookie(ownProps.cookieType, ownProps.cookieDim, size));
    },
}); };
var container = connect(makeMapStateToProps, mapDispatchToProps);
export var MeasuredCookieConnector = function (component) {
    // this is a typing hack because TS got really confused by redux generics
    return (container(component));
};
/** @deprecated */
var MeasuredContainer = MeasuredCookieConnector(Measured);
MeasuredContainer.displayName = 'MeasuredContainer';
export default MeasuredContainer;
//# sourceMappingURL=Measured.container.js.map